import { SPACE_LIST } from 'reactApp/constants/spaceList';

export const specialProductIds = {
    BusinessTariffId: 'business',
};

export const businessTariffMock = { id: specialProductIds.BusinessTariffId, space: { original: SPACE_LIST.gb_64 } };
